import {useEffect, useRef} from 'react';
import Mark from 'mark.js';

const HighlighterWrapper = ({
  children,
  keywords,style
}: {
  children: React.ReactNode;
  keywords: string[];
  style?:any
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const markInstance = new Mark(containerRef.current);
      markInstance.unmark({
        done: () => {
          markInstance.mark(keywords, {
            separateWordSearch: true,
            className: 'highlight',
            exclude: [
              '.MuiTablePagination-selectLabel',
              '.MuiTablePagination-select',
              '.MuiDataGrid-columnHeaderTitle',
              '.MuiRowsCount',
            ]
          });
        }
      });
    }
  }, [keywords, children]);

  return <div ref={containerRef} style={style}>{children}</div>;
};

export default HighlighterWrapper;
